import { render, staticRenderFns } from "./DeleteGroupForm.vue?vue&type=template&id=6967b612&"
import script from "./DeleteGroupForm.vue?vue&type=script&lang=js&"
export * from "./DeleteGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports